exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".switchContainer--1z3IT {\n\twidth: 100%;\n}\n\n\t.switchContainer--1z3IT .labelRoot--1DLO_ {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -webkit-flex;\n\t\tdisplay: -moz-box;\n\t\tdisplay: flex;\n\t\tmargin: 0 0 20px;\n\t\twidth: 100%;\n\t}\n\n\t.switchContainer--1z3IT .label--3iXkl {\n\t\t-webkit-box-flex: 1;\n\t\t-webkit-flex: 1 1;\n\t\t   -moz-box-flex: 1;\n\t\t        flex: 1 1;\n\t\t-webkit-user-select: none;\n\t\t   -moz-user-select: none;\n\t\t    -ms-user-select: none;\n\t\t        user-select: none;\n\t}\n", ""]);

// Exports
exports.locals = {
	"switchContainer": "switchContainer--1z3IT",
	"labelRoot": "labelRoot--1DLO_",
	"label": "label--3iXkl"
};